import BreakdownDisplay from './components/BreakdownDisplay'
import Display from './components/Display'
import PercentDisplay from './components/PercentDisplay'
import PercentLabelDisplay from './components/PercentLabelDisplay'
import Rating from './components/Rating'
import RatingCriteria from './components/RatingCriteria'
import Snippet from './components/Snippet'
import StarBreakdown from './components/StarBreakdown'

const Review = {
  BreakdownDisplay,
  Display,
  PercentDisplay,
  PercentLabelDisplay,
  Rating,
  RatingCriteria,
  Snippet,
  StarBreakdown,
}

export default Review
